import React, { useState } from 'react';
import { IShippingAddress } from '@/interfaces/shipping-address';
import Title from '@/components/title';
import { searchShippingAddresss } from '@/adapters/shipping-address';
import {
  ISearchShippingAddressReq,
  ISearchShippingAddressRes,
} from '@/interfaces/shipping-address';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ICustomer } from '@/interfaces/customer';
import ShippingAddressTable from './components/shipping-address-table';
import { Button, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { PlusOutlined } from '@ant-design/icons';
import { IDataModal } from '@/interfaces/dataModal';
import ShippingAddressModal from './components/shipping-address-modal';

interface IProps {
  data: ICustomer;
}

const _criteria: ISearchShippingAddressReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
  search: '',
  entryName: 'customer',
};

const _modal: IDataModal<IShippingAddress> = {
  open: false,
};

const ShippingAddressLogistic = ({ data }: IProps) => {
  const [criteria, setCriteria] = useState<ISearchShippingAddressReq>({
    ..._criteria,
    entryId: data.id,
  });
  const [dataModal, setDataModal] =
    useState<IDataModal<IShippingAddress>>(_modal);

  const {
    data: shippingAddress,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery<AxiosResponse<ISearchShippingAddressRes>, Error>({
    queryKey: ['search-ShippingAddress', criteria],
    queryFn: async () => await searchShippingAddresss(criteria),
  });

  const onRefetch = () => {
    refetch();
    setDataModal({
      ..._modal,
    });
  };

  const onTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<IShippingAddress> | SorterResult<IShippingAddress>[],
  ) => {
    const newCriteria = { ...criteria };
    if (!Array.isArray(sorter)) {
      newCriteria.orderBy =
        (sorter.column?.dataIndex as keyof IShippingAddress) || '';
      newCriteria.orderType = sorter.order || '';
    }
    setCriteria({
      ...newCriteria,
      pageStart: Number(pagination.current || 1),
      pageSize: Number(pagination.pageSize || 10),
    });
  };

  return (
    <>
      <Title customClassName="text-lg text-blue-700" title={`ที่อยู่จัดส่ง`}>
        <Button
          ghost
          type="primary"
          className="max-w-[90px]"
          onClick={() => {
            setDataModal({
              ...dataModal,
              open: true,
            });
          }}
        >
          <PlusOutlined /> เพิ่มใหม่
        </Button>
      </Title>
      <ShippingAddressTable
        criteria={criteria}
        ShippingAddress={shippingAddress?.data || { data: [], totalRecords: 0 }}
        loading={isLoading || isRefetching}
        onEditData={item => setDataModal({ id: item.id, item, open: true })}
        onDelete={onRefetch}
        onTableChange={onTableChange}
      />
      <ShippingAddressModal
        customerId={data?.id}
        dataModal={dataModal}
        handleCancel={() =>
          setDataModal({
            ..._modal,
          })
        }
        handleOk={() => onRefetch()}
      />
    </>
  );
};

export default ShippingAddressLogistic;
